(() => {
  'use strict';
  if (window.__coPdpPolishLoaded) return;
  window.__coPdpPolishLoaded = true;
  const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const initGallery = root => {
    const gallery = root.querySelector('[data-co-gallery]');
    if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('[data-co-track]');
    const slides = Array.from(track.querySelectorAll('[data-co-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-co-thumb]'));
    const count = gallery.querySelector('[data-co-count]');
    const prev = gallery.querySelector('[data-co-prev]');
    const next = gallery.querySelector('[data-co-next]');
    let index = 0, frame = 0;
    const sync = () => {
      frame = 0;
      index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };
    const go = i => {
      const target = slides[Math.max(0, Math.min(slides.length - 1, i))];
      if (!target) return;
      track.scrollTo({left: track.scrollLeft + target.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: motion()});
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', event => { event.preventDefault(); go(i); }));
    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(sync); }, {passive: true});
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();go(index + (event.key === 'ArrowRight' ? 1 : -1));}
    });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
    const dialog = root.querySelector('[data-co-zoom]');
    if (dialog && typeof dialog.showModal === 'function') {
      gallery.querySelectorAll('[data-co-open-zoom]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        const image = dialog.querySelector('img');
        image.src = link.href;
        image.alt = link.querySelector('img')?.alt || 'Paperloops ergonomic office chair';
        dialog.showModal();
      }));
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    }
    gallery.classList.add('is-enhanced');sync();
  };
  const initFeatures = section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const details = Array.from(section.querySelectorAll('[data-co-feature]'));
    const panels = Array.from(section.querySelectorAll('[data-co-feature-panel]'));
    const activate = active => {
      if (!active.open) return;
      panels.forEach(panel => {panel.hidden = panel.dataset.coFeaturePanel !== active.dataset.coFeature;});
      details.forEach(detail => { if (detail !== active) detail.open = false; });
    };
    details.forEach(detail => detail.addEventListener('toggle', () => activate(detail)));
    section.classList.add('is-enhanced');
    if (details[0]) { details[0].open = true; activate(details[0]); }
  };
  const initPurchase = root => {
    if (root.dataset.purchaseReady) return;
    root.dataset.purchaseReady = 'true';
    const form = root.querySelector('#co-chair-product-form');
    const mainButton = root.querySelector('[data-co-main-submit]');
    const variantControl = form?.querySelector('[name="id"]');
    if (!form || !mainButton || !variantControl) return;
    let variants;
    try { variants = JSON.parse(root.querySelector('[data-co-variants]').textContent); }
    catch { return; }
    const stock = root.querySelector('[data-co-stock]');
    const was = root.querySelector('[data-co-was]');
    const selected = () => variants.find(v => String(v.id) === String(variantControl.value));
    const submitText = mainButton.querySelector('.js-product-form-submit-btn-text');
    const syncExternal = () => {
      const v = selected();
      const busy = mainButton.classList.contains('loading');
      const unavailable = !v || !v.available;
      document.querySelectorAll('[data-co-submit]').forEach(button => {
        const disabled = busy || unavailable;
        if (button.disabled !== disabled) button.disabled = disabled;
        button.setAttribute('aria-busy', String(busy));
        const label = button.querySelector('[data-co-submit-label]');
        if (label) label.textContent = busy ? (document.querySelector('[data-co-main]')?.dataset.labelAdding || 'Adding…') : unavailable ? (document.querySelector('[data-co-main]')?.dataset.labelSold || 'Sold out') : (document.querySelector('[data-co-main]')?.dataset.labelAdd || 'Add to cart');
      });
    };
    const update = (changeUrl = false) => {
      const v = selected();
      if (!v) return;
      document.querySelectorAll('[data-co-current-price]').forEach(el => {el.textContent = v.money;});
      if (was) { was.textContent = v.compareMoney; was.hidden = !v.onSale; }
      if (stock) {stock.textContent = v.stockLabel;stock.dataset.inStock = String(v.inStock);}
      const dispatch = root.querySelector('[data-pp-dispatch]');
      if (dispatch) dispatch.hidden = !v.available || !v.inStock;
      mainButton.disabled = !v.available;
      if (submitText) submitText.textContent = v.available ? (document.querySelector('[data-co-main]')?.dataset.labelAdd || 'Add to cart') : (document.querySelector('[data-co-main]')?.dataset.labelSold || 'Sold out');
      if (changeUrl) {
        const url = new URL(window.location.href);url.searchParams.set('variant', v.id);history.replaceState({}, '', url);
      }
      syncExternal();
    };
    variantControl.addEventListener('change', () => update(true));
    new MutationObserver(syncExternal).observe(mainButton, {attributes:true,attributeFilter:['class','disabled']});
    const error = root.querySelector('.js-product-form-error-wrapper');
    if (error) new MutationObserver(() => {
      if (!error.hidden && error.textContent.trim()) error.scrollIntoView({behavior:motion(), block:'center'});
    }).observe(error, {attributes:true,attributeFilter:['hidden']});
    const dock = root.querySelector('[data-co-dock]');
    let pending = 0;
    const updateDock = () => {
      pending = 0;
      if (!dock || !root.isConnected) return;
      const rect = mainButton.getBoundingClientRect();
      const final = document.querySelector('[data-co-final-submit]')?.getBoundingClientRect();
      const finalVisible = !!final && final.top < window.innerHeight && final.bottom > 0;
      const visible = rect.bottom < 0 && !finalVisible;
      if (dock.dataset.visible !== String(visible)) dock.dataset.visible = String(visible);
      dock.setAttribute('aria-hidden', String(!visible));
    };
    const queue = () => {if (!pending) pending = requestAnimationFrame(updateDock);};
    window.addEventListener('scroll', queue, {passive:true});
    window.addEventListener('resize', queue, {passive:true});
    document.addEventListener('toggle', queue, true);
    update();updateDock();
  };
  const openAnchor = hash => {
    if (!hash || hash.length < 2) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch { return; }
    if (target?.matches('.co-pdp details, details.co-anchor')) target.open = true;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('.co-pdp a[href^="#"]');
    if (link) openAnchor(link.hash);
  });
  window.addEventListener('hashchange', () => openAnchor(window.location.hash));
  const init = () => {
    openAnchor(window.location.hash);
    document.querySelectorAll('[data-co-main]').forEach(root => {initGallery(root);initPurchase(root);});
    document.querySelectorAll('[data-co-features]').forEach(initFeatures);
    document.querySelectorAll('.co-proof-section video').forEach(video => {
      if (video.dataset.coReady) return;
      video.dataset.coReady = 'true';
      video.addEventListener('play', () => document.querySelectorAll('.co-proof-section video').forEach(other => {if (other !== video) other.pause();}));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});else init();
  document.addEventListener('shopify:section:load', init);
})();

